import React, { FC } from 'react';
import { EnterpriseHeaderTop } from './EnterpriseHeaderTop';
import { EnterpriseHeaderInfos } from './EnterpriseHeaderInfos';
import { BigLineSeparator } from '../../../components/separator/LineSeparator';
import { EntityCardHeader } from '../../../entity/components/EntityCardComponents';

type Props = {
  allDecisionsLink: string;
};

export const EnterpriseHeader: FC<Props> = ({ allDecisionsLink }) => (
  <EntityCardHeader id="enterprise-header">
    <EnterpriseHeaderTop allDecisionsLink={allDecisionsLink} />
    <BigLineSeparator />
    <EnterpriseHeaderInfos />
  </EntityCardHeader>
);
